
export * from './organisms';
export * from './messages';

import { 
    NotificationOrganisms
} from "./organisms";
import {
    NotificationMessageTemplates,
} from './messages';


export const NotificationComponents = [
    ...NotificationOrganisms,
    ...NotificationMessageTemplates,
];